export default "__VITE_ASSET__BlM_SZlN__"